import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick-pnth";
import PrevArrow from "./prevarrow";
import NextArrow from "./nextarrow";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Global from "../../global";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import LazyDiv from "../lazy/lazydiv";
import lanPlaceholder from "../img/newlanplace.png";
import { Helmet } from "react-helmet";
import VideoModal from "../modals/videoModal";
import Icon from "../icon/icon";
import { RTL } from "../../global";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const HeroCarousel = (props) => {
  const mounted = useRef(false);
  const slider = useRef(null);
  const { t } = useTranslation(["translation"]);

  const settings = {
    speed: 800,
    arrows: true,
    dots: true,
    fade: false,
    infinite: true,
    rtl: RTL,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: props.information.autoPlay,
    autoplaySpeed: parseInt(props.information.autoPlayTimer),
    prevArrow: <PrevArrow></PrevArrow>,
    nextArrow: <NextArrow></NextArrow>,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true,
          arrows: false,
          initialSlide: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          autoplay: props.information.autoPlay,
          autoplaySpeed: parseInt(props.information.autoPlayTimer),
          beforeChange: (current, next) => {
            if (next === -1) {
              let list = document.getElementsByClassName("slick-track");
              list[0].classList.add("transform-start");
            } else {
              let list = document.getElementsByClassName("slick-track");
              list[0].classList.remove("transform-start");
            }
          },
        },
      },
    ],
  };

  const init = { playlist: [] };
  const y_init = { items: [] };
  const [elemhc, setElemHc] = useState([]);
  const [elemItemhc, setItemHc] = useState([]);
  const [playlisthc, setPlaylistHc] = useState(
    Global.VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplayhc, setElemDisplayHc] = useState(true);
  const [videoShow, setVideoShow] = useState(false);
  const [trailer, setTrailer] = useState("");
  const history = useHistory();

  const onOpenVideoModal = () => {
    setVideoShow(true);
  };
  const addTrailer = (event, id) => {
    event.preventDefault();
    setTrailer(id);
    onOpenVideoModal();
  };
  const onCloseVideoModal = () => {
    setVideoShow(false);
  };

  const goTo = (event, loc) => {
    history.push(loc);
  };
  useEffect(() => {
    mounted.current = true;

    const NewsDetail = async () => {
      if (mounted.current) {
        /* eslint-disable no-unused-vars */
        setElemHc(props.information);
        if (
          props.information.playlistId !== "" &&
          props.information.playlistId !== null
        ) {
          NplaylistDetail(
            props.information.playlistId,
            props.information.devices[0].itemSize
          );
        }
        setElemDisplayHc(props.information.devices[0].itemVisibility);
        setItemHc(props.information.items);
        /* eslint-disable no-unused-vars */
      }
    };

    const NplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      if (Global.VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistHc(result.data);
            }
          },
          (error) => {
            SetError(true);
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistHc(result.data);
            }
          },
          (error) => {
            SetError(true);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    NewsDetail();
    isLoading(false);

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  if (elemdisplayhc && !error && !loading && props.information) {
    return (
      <section
        className="iq-main-slider p-0"
        style={{ backgroundImage: `url(${lanPlaceholder}) no-repeat,center` }}
      >
        <Slider
          ref={slider}
          className="slider m-0 p-0 home-slider"
          {...settings}
          style={{ backgroundImage: `url(${lanPlaceholder}) no-repeat,center` }}
        >
          {elemItemhc !== null
            ? elemItemhc?.map((item, index) =>
                item.itemid.devices[0].itemVisibility ? (
                  <LazyDiv
                    key={index}
                    className={"slide slick-bg s-bgr-" + index}
                    onClick={(event) => {
                      goTo(
                        event,
                        item.itemid.pageType === "externalPage"
                          ? item.itemid.externalPage
                          : item.itemid.pageType === "internalPage"
                          ? item.itemid.internalPage
                          : item.itemid.pageType === "videoPage"
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.pageType +
                            "/" +
                            item.itemid.videoId
                          : item.itemid.urlName !== ""
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.urlName
                          : item.itemid.pageType + "/" + item.itemid._id
                      );
                    }}
                  >
                    <Helmet>
                      {item.itemid.bannerImage ? (
                        <style type="text/css">
                          {`.s-bgr-` +
                            index +
                            `{ background-image:url(` +
                            getAWSUrl() +
                            item.itemid.bannerImage.imagekey +
                            `)}`}
                        </style>
                      ) : (
                        <style type="text/css">
                          {`.s-bgr-` +
                            index +
                            `{ background-image:url(` +
                            getAWSUrl() +
                            "" +
                            `)}`}
                        </style>
                      )}

                      {item.itemid.portraitThumbnail ? (
                        <style type="text/css">
                          {`
       
                          @media (max-width: 450px) {
                          .s-bgr-` +
                            index +
                            `{ background-image:url(` +
                            getAWSUrl() +
                            item.itemid.portraitThumbnail.imagekey +
                            `)}
                          }
`}
                        </style>
                      ) : (
                        <style type="text/css">
                          {`
     
                        @media (max-width: 450px) {
                        .s-bgr-` +
                            index +
                            `{ background-image:url(` +
                            getAWSUrl() +
                            "" +
                            `)}
                        }
`}
                        </style>
                      )}
                    </Helmet>
                    <LazyImg
                      src={
                        window.innerWidth <= 450
                          ? item.itemid.bannerImage
                            ? getAWSUrl() +
                              item.itemid.portraitThumbnail.imagekey
                            : ""
                          : item.itemid.bannerImage
                          ? getAWSUrl() + item.itemid.bannerImage.imagekey
                          : ""
                      }
                      orient={"landscape"}
                      style={{
                        position: "absolute",
                        height: "auto",
                        width: "100%",
                        top: "0",
                        display: "none",
                      }}
                    />

                    <div className="container-fluid position-relative h-100">
                      <div
                        className={
                          elemhc.displayNameVisibility === "Hide Always"
                            ? "slider-inner h-100 hidden"
                            : "slider-inner h-100"
                        }
                      >
                        <div className="row align-items-center  h-100">
                          <div className="col-xl-6 col-lg-12 col-md-12">
                            {/*      <a href="#!">
                    <div className="channel-logo" data-animation-in="fadeInLeft" data-delay-in="0.5">
                     <img src={getAWSUrl()+localStorage.getItem("prev_logo")} className="c-logo" alt="smott" />
                    </div>
                  </a> */}
                            <h1
                              className="slider-text big-title title text-uppercase shadow-text "
                              data-animation-in="fadeInLeft"
                              data-delay-in="0.6"
                            >
                              {item.itemid.displayName}
                            </h1>
                            <div
                              className="d-flex align-items-center meta_data"
                              data-animation-in="fadeInUp"
                              data-delay-in={1}
                            >
                              <span className="badge badge-secondary p-2 shadow-text host">
                                {item.itemid.rating}
                              </span>
                              <span className="ml-3 shadow-text host">
                                {item.itemid.genre}
                              </span>
                            </div>
                            <p
                              className="shadow-text"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              {item.itemid.pageType === "videoPage"
                                ? ""
                                : item.itemid.description}
                            </p>
                            <div
                              className="d-flex align-items-center r-mb-23 opac"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              <Anchor
                                to={
                                  item.itemid.pageType === "externalPage"
                                    ? item.itemid.externalPage
                                    : item.itemid.pageType === "internalPage"
                                    ? item.itemid.internalPage
                                    : item.itemid.pageType === "videoPage"
                                    ? "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      item.itemid.pageType +
                                      "/" +
                                      item.itemid.videoId
                                    : item.itemid.urlName !== ""
                                    ? "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      item.itemid.urlName
                                    : item.itemid.pageType +
                                      "/" +
                                      item.itemid._id
                                }
                                className="btn btn-hover"
                              >
                                <i
                                  className="fa fa-play mr-2"
                                  aria-hidden="true"
                                />
                                {t("btn_Play")}
                              </Anchor>
                            </div>
                          </div>
                        </div>
                        <div className="trailor-video">
                          <a href="#!" className="video-open playbtn">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              width="80px"
                              height="80px"
                              viewBox="0 0 213.7 213.7"
                              enableBackground="new 0 0 213.7 213.7"
                              xmlSpace="preserve"
                            >
                              <polygon
                                className="triangle"
                                fill="none"
                                strokeWidth={7}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={10}
                                points="73.5,62.5 148.5,105.8 73.5,149.1 "
                              />
                              <circle
                                className="circle"
                                fill="none"
                                strokeWidth={7}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={10}
                                cx="106.8"
                                cy="106.8"
                                r="103.3"
                              />
                            </svg>
                            <span className="w-trailor">
                              {t("btn_Watch_Trailer")}
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </LazyDiv>
                ) : (
                  ""
                )
              )
            : ""}

          {elemhc.playlistId !== null && elemhc.playlistId !== undefined
            ? Global.VCMS === "YouTube"
              ? playlisthc.items.map((item, index) => (
                  <LazyDiv
                    key={index}
                    className={"slide slick-bg s-bg1-" + index}
                    orient={"landscape"}
                    onClick={(event) =>
                      goTo(
                        event,
                        "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.contentDetails.videoId
                      )
                    }
                  >
                    {/* {item.ContentType === "Premium" ? <Icon></Icon> : ""} */}
                    <Helmet>
                      <style type="text/css">
                        {`
     .s-bg1-` +
                          index +
                          `{ background-image:url("https://i.ytimg.com/vi/` +
                          item.contentDetails.videoId +
                          `/maxresdefault.jpg"
                      )}
                    
`}
                      </style>

                      {item.snippet.thumbnails.maxres ? (
                        <style type="text/css">
                          {`
                
                                 @media (max-width: 450px) {
                                   .s-bg1-` +
                            index +
                            `{ background-image:url("https://i.ytimg.com/vi/` +
                            item.contentDetails.videoId +
                            `/maxresdefault.jpg")}
                                   }
         `}
                        </style>
                      ) : (
                        <style type="text/css">
                          {`
                               @media (max-width: 450px) {
                                 .s-bg1-` +
                            index +
                            `{ background-image:url(` +
                            "" +
                            `)}
                                 }
       `}
                        </style>
                      )}
                    </Helmet>
                    <LazyImg
                      src={
                        window.innerWidth <= 450
                          ? "https://i.ytimg.com/vi/" +
                            item.contentDetails.videoId +
                            "/maxresdefault.jpg"
                          : "https://i.ytimg.com/vi/" +
                            item.contentDetails.videoId +
                            "/maxresdefault.jpg"
                      }
                      orient={"landscape"}
                      style={{
                        position: "absolute",
                        height: "auto",
                        width: "100%",
                        top: "0",
                        display: "none",
                      }}
                    />

                    <div className="container-fluid position-relative h-100">
                      <div
                        className={
                          elemhc.displayNameVisibility === "Hide Always"
                            ? "slider-inner h-100 hidden"
                            : "slider-inner h-100"
                        }
                      >
                        <div className="row align-items-center  h-100">
                          <div className="col-xl-6 col-lg-12 col-md-12">
                            {/*  <a href="#!">
                <div className="channel-logo" data-animation-in="fadeInLeft" data-delay-in="0.5">
                  <img src={getAWSUrl()+localStorage.getItem("prev_logo")} className="c-logo" alt="streamit" />
                </div>
              </a> */}
                            <h1
                              className="slider-text big-title title text-uppercase shadow-text "
                              data-animation-in="fadeInLeft"
                              data-delay-in="0.6"
                            >
                              {item.snippet.title}
                            </h1>
                            <div
                              className="d-flex align-items-center meta_data"
                              data-animation-in="fadeInUp"
                              data-delay-in={1}
                            >
                              <span className="badge badge-secondary p-2 shadow-text host">
                                {""}
                              </span>
                              <span className="ml-3 shadow-text host">
                                {""}
                              </span>
                            </div>
                            <p
                              className="shadow-text"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              {item.snippet.description}
                            </p>
                            <div
                              className="d-flex align-items-center r-mb-23 opac"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              <Link
                                to={
                                  "/" +
                                  props.match.params.AppId +
                                  "/videoPage/" +
                                  item.contentDetails.videoId
                                }
                                className="btn btn-hover"
                              >
                                <i
                                  className="fa fa-play mr-2"
                                  aria-hidden="true"
                                />
                                {t("btn_Play")}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </LazyDiv>
                ))
              : playlisthc.playlist.map((item, index) => (
                  <LazyDiv
                    key={index}
                    className={"slide slick-bg s-bg1-" + index}
                    orient={"landscape"}
                    onClick={(event) =>
                      goTo(
                        event,
                        "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.mediaid
                      )
                    }
                  >
                    {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                    <Helmet>
                      <style type="text/css">
                        {`
       .s-bg1-` +
                          index +
                          `{ background-image:url(` +
                          item.image +
                          `)}
                      
`}
                      </style>

                      {item.PortraitImage ? (
                        <style type="text/css">
                          {`
                  
                                   @media (max-width: 450px) {
                                     .s-bg1-` +
                            index +
                            `{ background-image:url(` +
                            item.PortraitImage +
                            `)}
                                     }
           `}
                        </style>
                      ) : (
                        <style type="text/css">
                          {`
                                 @media (max-width: 450px) {
                                   .s-bg1-` +
                            index +
                            `{ background-image:url(` +
                            "" +
                            `)}
                                   }
         `}
                        </style>
                      )}
                    </Helmet>
                    <LazyImg
                      src={
                        window.innerWidth <= 450
                          ? item.PortraitImage
                          : item.images[5].src
                      }
                      orient={"landscape"}
                      style={{
                        position: "absolute",
                        height: "auto",
                        width: "100%",
                        top: "0",
                        display: "none",
                      }}
                    />

                    <div className="container-fluid position-relative h-100">
                      <div
                        className={
                          elemhc.displayNameVisibility === "Hide Always"
                            ? "slider-inner h-100 hidden"
                            : "slider-inner h-100"
                        }
                      >
                        <div className="row align-items-center  h-100">
                          <div className="col-xl-6 col-lg-12 col-md-12">
                            {/*  <a href="#!">
                  <div className="channel-logo" data-animation-in="fadeInLeft" data-delay-in="0.5">
                    <img src={getAWSUrl()+localStorage.getItem("prev_logo")} className="c-logo" alt="streamit" />
                  </div>
                </a> */}
                            <h1
                              className="slider-text big-title title text-uppercase shadow-text "
                              data-animation-in="fadeInLeft"
                              data-delay-in="0.6"
                            >
                              {item.title}
                            </h1>
                            <div
                              className="d-flex align-items-center meta_data"
                              data-animation-in="fadeInUp"
                              data-delay-in={1}
                            >
                              <span className="badge badge-secondary p-2 shadow-text host">
                                {item.PgRating}
                              </span>
                              <span className="ml-3 shadow-text host">
                                {item.Genre}
                              </span>
                            </div>
                            <p
                              className="shadow-text"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              {item.ShortDescription}
                            </p>
                            <div
                              className="d-flex align-items-center r-mb-23 opac"
                              data-animation-in="fadeInUp"
                              data-delay-in="1.2"
                            >
                              <Link
                                to={
                                  "/" +
                                  props.match.params.AppId +
                                  "/videoPage/" +
                                  item.mediaid
                                }
                                className="btn btn-hover"
                              >
                                <i
                                  className="fa fa-play mr-2"
                                  aria-hidden="true"
                                />
                                {t("btn_Play")}
                              </Link>
                            </div>
                          </div>
                        </div>
                        {item.TrailerId ? (
                          <div className="trailor-video">
                            <Link
                              to={"#!"}
                              className="video-open playbtn"
                              onClick={(event) => {
                                addTrailer(event, item.TrailerId);
                              }}
                            >
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="80px"
                                height="80px"
                                viewBox="0 0 213.7 213.7"
                                enableBackground="new 0 0 213.7 213.7"
                                xmlSpace="preserve"
                              >
                                <polygon
                                  className="triangle"
                                  fill="none"
                                  strokeWidth={7}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  points="73.5,62.5 148.5,105.8 73.5,149.1 "
                                />
                                <circle
                                  className="circle"
                                  fill="none"
                                  strokeWidth={7}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  cx="106.8"
                                  cy="106.8"
                                  r="103.3"
                                />
                              </svg>
                              <span className="w-trailor shadow-text">
                                {t("btn_Watch_Trailer")}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </LazyDiv>
                ))
            : ""}
        </Slider>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
          <symbol
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 44 44"
            width="44px"
            height="44px"
            id="circle"
            fill="none"
            stroke="currentColor"
          >
            <circle r={20} cy={22} cx={22} id="test" />
          </symbol>
        </svg>

        <VideoModal
          open={videoShow}
          onCloseModal={onCloseVideoModal}
          onOpenModal={onOpenVideoModal}
          trailer={trailer}
        ></VideoModal>
      </section>
    );
  } else if (elemdisplayhc && !error && loading) {
    return (
      <div
        style={{
          minHeight: "500px",
          backgroundImage: `url(${lanPlaceholder}) no-repeat,center`,
        }}
      >
        <LazyImg
          src=""
          orient="landscape"
          style={{ height: "90vh", width: "100%" }}
        ></LazyImg>
      </div>
    );
  } else {
    return (
      <div
        className={!elemdisplayhc ? "no-slider" : ""}
        style={{
          minHeight: "500px",
          backgroundImage: `url(${lanPlaceholder}) no-repeat,center`,
        }}
      >
        <LazyImg
          src=""
          orient="landscape"
          style={{ height: "90vh", width: "100%" }}
        ></LazyImg>
      </div>
    );
  }
};
export default HeroCarousel;
